const CHAR_DELAY = 35;
const FADE_DURATION = 300;

function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom > 0;
}

function initTypingFade() {
  const elements = document.querySelectorAll('.typing-fade');
  if (!elements.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          animateElement(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  elements.forEach((el) => {
    prepareElement(el);

    // Reveal element now that chars are individually hidden
    el.style.visibility = 'visible';

    if (isInViewport(el)) {
      setTimeout(() => animateElement(el), 500);
    } else {
      observer.observe(el);
    }
  });
}

function prepareElement(el) {
  const text = el.textContent;
  el.textContent = '';
  el.setAttribute('aria-label', text);

  const inner = document.createElement('span');
  inner.className = 'typing-fade__inner';
  inner.setAttribute('aria-hidden', 'true');

  const createChar = (char) => {
    const span = document.createElement('span');
    span.className = 'typing-fade__char';
    // Inline style guarantees opacity:0 regardless of theme CSS cascade
    span.style.cssText = 'opacity:0;transition:opacity 300ms ease;display:inline;white-space:pre;';
    span.textContent = char;
    return span;
  };

  // Split into words + whitespace so line breaks only happen between words.
  // Each word is wrapped in an inline-block span (white-space:nowrap) so its
  // characters never break mid-word on small screens.
  text.split(/(\s+)/).forEach((token) => {
    if (token === '') return;

    if (/^\s+$/.test(token)) {
      // Whitespace: plain text node (no span) so the browser collapses a
      // trailing space when a line wraps — avoids a visible gap/décalage.
      inner.appendChild(document.createTextNode(token));
      return;
    }

    const word = document.createElement('span');
    word.className = 'typing-fade__word';
    word.style.cssText = 'display:inline-block;white-space:nowrap;';
    token.split('').forEach((char) => word.appendChild(createChar(char)));
    inner.appendChild(word);
  });

  el.appendChild(inner);
}

function animateElement(el) {
  const chars = el.querySelectorAll('.typing-fade__char');
  const total = chars.length;

  el.classList.add('typing-fade--animating');

  chars.forEach((char, i) => {
    setTimeout(() => {
      char.style.opacity = '1';

      if (i === total - 1) {
        setTimeout(() => {
          el.classList.remove('typing-fade--animating');
          el.classList.add('typing-fade--done');
        }, FADE_DURATION);
      }
    }, i * CHAR_DELAY);
  });
}

document.addEventListener('DOMContentLoaded', initTypingFade);
